<template>
    <v-container>
        <v-row >
            <v-col cols="12" sm="6" offset-sm="3">
                <v-card>
                    <v-card-title class="headline">Ověření e-mailu</v-card-title>
                    <v-card-text>
                        <div v-if="loading">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                            <p>Probíhá ověření, čekejte prosím...</p>
                        </div>
                        <v-alert v-if="error" color="error" dismissible>
                            {{ error }}
                        </v-alert>
                        <v-alert v-else-if="success" color="success" dismissible>
                            {{ success }}
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { ACTIVATE_EMAIL_REQUEST } from '../store/actions/user'

    export default {
        props: {
            token: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                loading: false,
                error: null,
                success: null,
            };
        },
        async created () {
            try {
                this.loading = true;
                await this.$store.dispatch('user/' + ACTIVATE_EMAIL_REQUEST, { token: this.token });
                this.success = 'Váš e-mail byl úspěšně ověřen.';
            } catch (e) {
                this.error = e.response.data.message || 'Došlo k chybě. Zkuste to prosím později.';
            } finally {
                this.loading = false;
            }
        },
    }
</script>
